/* @license
 * Copyright 2026 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Renderer} from '../three-components/Renderer.js';

/**
 * This file is intended to be imported into any test suite that requires
 * WebGL/Renderer initialization. It provides a global setup hook that skips
 * the suite if the environment does not support rendering.
 */
suiteSetup(function() {
  if (!Renderer.singleton.canRender) {
    console.warn(
        'WebGL is not available in this environment. Skipping test suite dynamically.');
    this.skip();
  }
});
